module.exports = __webpack_public_path__ + "static/img/amp-acoustic.3223717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp-acoustic.png
// module id = 2ctc
// module chunks = 12